import type { FC } from "react";
import { AssistantAvatarMood } from "@/ui/AssistantAvatar/assistantAvatarConfig";

type BrowPair = readonly [left: string, right: string];

const RELAXED: BrowPair = ["M45 50 Q50 47.5 55 49.5", "M65 49.5 Q70 47.5 75 50"];

/** Thinking raises one brow, oops knits them, done lifts both. */
const BROWS: Record<AssistantAvatarMood, BrowPair> = {
	[AssistantAvatarMood.Idle]: RELAXED,
	[AssistantAvatarMood.Talking]: RELAXED,
	[AssistantAvatarMood.NeedsYou]: RELAXED,
	[AssistantAvatarMood.Thinking]: ["M45 50 Q50 47.5 55 49.5", "M65 47 Q70 43.5 75 46.5"],
	[AssistantAvatarMood.Oops]: ["M45 49.5 Q50 49 55 46.5", "M65 46.5 Q70 49 75 49.5"],
	[AssistantAvatarMood.Done]: ["M45 48 Q50 45 55 47.5", "M65 47.5 Q70 45 75 48"],
};

export const HumanBrows: FC<{ mood: AssistantAvatarMood; color: string }> = ({ mood, color }) => (
	<>
		{BROWS[mood].map((d) => (
			<path key={d} d={d} fill="none" stroke={color} strokeWidth={2.4} strokeLinecap="round" />
		))}
	</>
);
